import { connect } from "react-redux";
import { createSelector } from "reselect";
import { Maybe } from "true-myth";

import { IOption } from "components/shared/dropdown";
import TimeBlockModal, {
  IBlockModalData,
} from "components/schedule/time_block_modal";
import {
  saveUnavail,
  saveUnavailException,
  deleteUnavail,
} from "actions/scheduling";
import {
  BlockActionTypes,
  INewShift,
  saveShift,
  deleteShift,
  closeBlockModal,
} from "actions/scheduling/blocks";
import {
  getScheduleDates,
  getEmployeeOptions,
  getAllRoles,
  IEmployeeDropdownOption,
  IRoleDropdownOption,
} from "helpers/schedule/time_block_modal";
import {
  selectOrderedSchedule,
  selectBlockModalData,
} from "store/select/scheduling";
import { IRootStateProps } from "types/reducers";
import { IShift, IPosUser, IUnavailabilityBlock } from "types/schedules";
import { LDFlags } from "interfaces/context";
import { selectFeatureFlags } from "store/select/context";

interface IPropsFromState {
  allEmployeeOptions: IEmployeeDropdownOption[];
  allRoleOptions: IRoleDropdownOption[];
  blockModalData: Maybe<IBlockModalData>;
  schedule: IRootStateProps["scheduling"]["schedule"];
  scheduleDates: Array<IOption<Date>>;
  featureFlags: LDFlags;
}

interface IMapDispatchToProps {
  saveShift: (
    shift: INewShift,
    existingShift: Maybe<IShift>,
    existingAssignee: Maybe<IPosUser>
  ) => BlockActionTypes;
  deleteShift: (shift: IShift, assignee: Maybe<IPosUser>) => BlockActionTypes;
  saveUnavail: (unavail: IUnavailabilityBlock) => void;
  saveUnavailException: (exception: IUnavailabilityBlock) => void;
  deleteUnavail: (unavail: IUnavailabilityBlock) => void;
  closeBlockModal: () => void;
}

const mapStateToProps = createSelector(
  selectBlockModalData,
  selectOrderedSchedule,
  selectFeatureFlags,
  (blockModalData, schedule, featureFlags): IPropsFromState => {
    const scheduleDates: Array<IOption<Date>> = getScheduleDates(
      schedule.startDate,
      schedule.endDate
    );

    return {
      blockModalData,
      schedule,
      scheduleDates,
      allEmployeeOptions: getEmployeeOptions(schedule.people),
      allRoleOptions: getAllRoles(schedule.people),
      featureFlags,
    };
  }
);

const mapDispatchToProps: IMapDispatchToProps = {
  closeBlockModal,
  deleteShift,
  deleteUnavail,
  saveShift,
  saveUnavail,
  saveUnavailException,
};

const ScheduleContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TimeBlockModal);

export default ScheduleContainer;
